import $ from "jquery";

const singleProductsAttribute = () => {
  const init = () => {
    exec();
  };

  const exec = () => {
    $(function () {
      const readMoreButton = $(".js-single__section-info .info__read-more");
      const readLessButton = $(".js-single__section-info .info__read-less");
      const text = $(".js-single__section-info .info__text");

      text.each(function () {
        const $height = parseInt($(this).css("height"));
        const $maxHeight = 48;

        if ($height > $maxHeight) {
          $(this).css("max-height", "3em");
          $(this).css("overflow", "hidden");
          $(this).parent().find(".info__read-more").css("display", "block");
        }
      });

      readMoreButton.on("click", function () {
        $(this).parent().find(".info__text").css("overflow", "visible");
        $(this).parent().find(".info__text").css("max-height", "none");
        $(this).css("display", "none");
        $(this).parent().find(".info__read-less").css("display", "block");
      });

      readLessButton.on("click", function () {
        $(this).parent().find(".info__text").css("overflow", "hidden");
        $(this).parent().find(".info__text").css("max-height", "3em");
        $(this).css("display", "none");
        $(this).parent().find(".info__read-more").css("display", "block");
      });
    });
  };

  init();
};

try {
  singleProductsAttribute();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
